// extracted by mini-css-extract-plugin
export default {"root":"Card_root__UAmJF","white":"Card_white__a5FQo","grey":"Card_grey__mddvV"};